var DwSpamScripts = DwSpamScripts || {};
e4.forms = {
    init: function () {
        if ( jQuery( '.js-e-form-dw, form[data-validate="true"]' ).length > 0 ) {
            e4.util.require.js( e4.settings.require.jQueryValidate, function () {
                e4.forms.validate.loadMsgTranlations();
                e4.forms.validate.init();
                e4.forms.mailchimp.init();
            } );
        }
        e4.forms.toggleState();
        e4.forms.setSubmitPage();
    },
    setSubmitPage: function () {
        jQuery( '.js-e-form-dw' ).find( 'input[name="SubmitPage"]' ).val( location.href );
    },
    toggleState: function () {
        //Toggle class on form groups to focus active fields and labels.
        jQuery( '.js-e-form-dw' ).find( '.form-group :input' ).on( 'focus blur', function ( event ) {
            var jThisFormGroup = jQuery( this ).closest( '.form-group' );
            if ( event.type === 'focus' ) {
                jThisFormGroup.addClass( 'has-focus' );
            }
            else {
                jThisFormGroup.removeClass( 'has-focus' );
            }
        } );
    },
    validate: {
        init: function () {
            if ( jQuery( '.js-e-form-dw, form[data-validate="true"]' ).length > 0 ) {
                e4.forms.validate.setDefaults();
                e4.forms.validate.bind();
                //e4.forms.validate.loadMsgTranlations(); // Moved to require callback
            }
        },
        setDefaults: function () {
            //Set validation plugin default settings.
            jQuery.validator.setDefaults( {
                //debug: true,
                validClass: '',
                errorClass: 'has-danger',
                highlight: function ( element, errorClass, validClass ) {
                    jQuery( element ).addClass( 'form-control-danger' ).removeClass( 'form-control-success' ).closest( '.form-group' ).addClass( errorClass ).removeClass( validClass );
                },
                unhighlight: function ( element, errorClass, validClass ) {
                    jQuery( element ).removeClass( 'form-control-danger' ).addClass( 'form-control-success' ).closest( '.form-group' ).removeClass( errorClass ).addClass( validClass );
                },
                errorPlacement: function ( jError, jElement ) {
                    jElement.closest( '.form-group' ).append( jError );
                },
                focusInvalid: false,
                invalidHandler: function ( form, validator ) {
                    var jFirstError = jQuery( validator.invalidElements()[ 0 ] );
                    if ( e4.util.isInViewport( jFirstError ) === true ) {
                        validator.focusInvalid();
                    }
                    else {
                        jFirstError.focus();
                        jQuery( window ).scrollTop( jFirstError.closest( '.form-group' ).offset().top * 0.875 );
                    }
                },
                submitHandler: function ( form ) {
                    if ( jQuery( form ).is( '.js-e-form-dw' ) === true ) {
                        //Read Dynamicweb spam script from inline script block inside the forms.
                        //DwSpamScripts = DwSpamScripts || {};
                        DwSpamScripts[ form.id ]( form );
                    } //console4.log( 'Submit' );
                    form.submit();
                }
            } );
        },
        bind: function () {
            //Bind validation method to all Dynamiweb forms and custom forms with data-validate="true" using default settings.
            jQuery( '.js-e-form-dw, form[data-validate="true"]' ).each( function () {
                jQuery( this ).validate();
            } );
        },
        loadMsgTranlations: function () {
            var strMsgLang = e4.settings.lang;
            if ( strMsgLang !== 'en' ) {
                if ( strMsgLang === 'nb' || strMsgLang === 'nn' ) {
                    strMsgLang = 'no';
                }
                else if ( strMsgLang === 'se' ) {
                    strMsgLang = 'sv';
                }
                if ( e4.settings.forms.validate.messages[ strMsgLang ] !== undefined ) {
                    jQuery.extend( jQuery.validator.messages, e4.settings.forms.validate.messages[ strMsgLang ] );
                }
                else {
                    e4.util.require.js( {
                        //test: undefined,
                        url: '//ajax.aspnetcdn.com/ajax/jquery.validate/1.16.0/localization/messages_' + strMsgLang + '.js',
                        fallback: '/files/system/espresso/design/js/vendor/jquery.validate.messages_' + strMsgLang + '.js',
                        callback: null
                    } );
                }
            }
        }
    },
    mailchimp: {
        init: function () {
            if ( jQuery( '.js-e-form-dw-mailchimp-signup' ).length > 0 ) {
                e4.forms.mailchimp.setSubmitHandler();
            }
        },
        setSubmitHandler: function () {
            jQuery( '.js-e-form-dw-mailchimp-signup' ).data( 'validator' ).settings.submitHandler = e4.forms.mailchimp.submitHandler;
        },
        submitHandler: function ( form ) {
            var jForm = jQuery( form );
            jQuery.ajax( {
                type: jForm.attr( 'method' ),
                url: jForm.find( 'input[name="MailChimp_SignUpURL"]' ).val().replace( '/post?', '/post-json?' ),
                data: jForm.serialize(),
                timeout: 1000,
                cache: false,
                dataType: 'jsonp',
                jsonp: 'c',
                // jsonpCallback: 'e4.forms.mailchimp.responseHandler',
                //contentType: 'application/json; charset=utf-8',
                context: form
            } ).always( function ( data ) {
                e4.forms.mailchimp.responseHandler( this, data );
            } );
        },
        responseHandler: function ( form, data ) {
            //console.log( form, data );
            var jForm = jQuery( form ),
                jMailChimpSignUp = jForm.closest( '.js-e-mailchimp-signup' );
            jMailChimpSignUp.find( '.js-e-msg' ).removeClass( 'in' );
            if ( data.result === 'success' ) {
                var jMsgSuccess = jMailChimpSignUp.find( '.js-e-msg-success' );
                if ( jMsgSuccess.html() === '' ) {
                    jMsgSuccess.html( data.msg );
                }
                jMailChimpSignUp.css( {
                    'min-height': ( function () {
                        return jMailChimpSignUp.height();
                    } )()
                } );
                jForm.fadeOut( e4.settings.animation.speed, function () {
                    jMsgSuccess.addClass( 'in' );
                } );
            }
            else if ( data.result === 'error' && data.msg.split( ' ' )[ 0 ] === jForm.find( 'input[name="EMAIL"]' ).val() ) {
                var jMsgMailExists = jMailChimpSignUp.find( '.js-e-msg-mail-exists' );
                if ( jMsgMailExists.html() === '' ) {
                    jMsgMailExists.html( data.msg );
                }
                else {
                    jMsgMailExists.html( jMsgMailExists.html().replace( '{{Email}}', jForm.find( 'input[name="EMAIL"]' ).val() ) );
                }
                jMsgMailExists.addClass( 'in' );
            }
            else {
                var jMsgError = jMailChimpSignUp.find( '.js-e-msg-error' );
                if ( jMsgError.html() === '' ) {
                    jMsgError.html( data.msg );
                }
                jMsgError.addClass( 'in' );
            }
        }
    }
};

/*
jQuery.validator.addMethod( 'localizedNumber', function ( value, element ) {
    var regExpLocalizedNumber = new RegExp( '^-?(?:\\d+|\\d{1,3}(?:\\' + vetoryl.logbook.number.intergerSeperator + '\\d{3})+)?(?:\\' + vetoryl.logbook.number.decimalSeperator + '\\d+)?$' );
    return this.optional( element ) || regExpLocalizedNumber.test( value );
}, jQuery.validator.messages.number );
*/

